import React, { useState } from 'react'

import styles from './ViewCart.module.scss'
import classNames from 'classnames/bind'
import { ButtonBase, Typography, Box, CircularProgress } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { clearAllCart, dataCartSelector, totalMoneyItemsCartSelector } from '~/redux/cartSlice'
import { convertPrice, isHidePlusFoodEnable, isValidArray } from '~/utils'
import CartItem from './CartItem'
import { useTranslation } from 'react-i18next'
import { selectRestaurant } from '~/redux/restaurantSlice'
import { loadingStates, paymentTypes } from '~/config/constant'
import { useNavigate } from 'react-router-dom'
import { path, route } from '~/routes/path'
import { MERCHANT_TYPE, keywordScreen } from '~/constants'
import request from '~/apis/request'
import { getMessageOrderError, transformToppings } from '~/utils/order'
import STORAGE_KEYS from '~/constants/localStorage'
import { useAppContext } from '~/contexts/AppContext'
import PopupDeleteItem from '~/views/Ordering/components/PopupDeleteItem'
import { ErrorServer } from '~/components'
const cx = classNames.bind(styles)

// View cart trên tablet
const ViewCart = () => {
  const [messageErr, setMessageErr] = useState('')
  const [loadingSubmit, setLoadingSubmit] = useState(false)
  const [error, setError] = useState(false)
  const [errorItemCart, setErrorItemCart] = useState(false)
  const [showPopupError, setShowPopupError] = useState(false)
  const [idErrorOrder, setIdErrorOrder] = useState(null)

  const { t } = useTranslation()
  const dispatch = useDispatch()
  const itemsCart = useSelector(dataCartSelector)
  const totalMoneyItemsCart = useSelector(totalMoneyItemsCartSelector) // Tổng tiền của các item
  const { paymentType, merchant_type, restaurantId, tableId, extraFeatures } =
    useSelector(selectRestaurant)
  const navigate = useNavigate()
  const { saveServingSessionID, setIsNotify } = useAppContext()
  const isHidePlusFoodEnabled = isHidePlusFoodEnable(extraFeatures) // Kiểm tra có cài đặt ẩn nút cộng hay không
  const isTypeSouvenir = merchant_type === MERCHANT_TYPE.SOUVENIR

  // Hàm di chuyển đến màn hình thành công tuỳ thuộc vào điều kiện
  const navigateToSuccessScreen = () => {
    const URL = isTypeSouvenir
      ? path.orderPlacedSouvenir
      : `${route.confirmedPaymentTablet}/${keywordScreen.ordering}`

    navigate(URL)
  }

  /** func format data request trước khi đẩy lên */
  const formattedData = () => {
    if (itemsCart?.length <= 0) return null
    const newData = itemsCart.map((foodItem) => {
      const { id, quantity, price, note, foodOptionTypes, is_buffet_item } = foodItem
      const newItem = {
        kind: is_buffet_item ? 'buffet_item_order' : 'food_order',
        food_item_id: id,
        quantity,
        price,
        note,
      }

      // nếu có topping
      if (isValidArray(foodOptionTypes)) {
        newItem.requests_food_options_attributes = transformToppings(foodOptionTypes)
      }
      return newItem
    })

    // if (noteOrder) {
    //   const newNote = {
    //     kind: 'order_note',
    //     note: noteOrder,
    //   }
    //   newData.push(newNote)
    // }

    return newData
  }

  /** func submit Order
   * nếu là payment_in_advance -> chuyển đến màn hình chọn phương thức thanh toán luôn
   * còn lại thực hiển tạo request bình thường
   */
  const onSubmitOrder = async () => {
    setMessageErr('')
    if (paymentType === paymentTypes.pay_in_advance) {
      navigate(path.choosePaymentMethod)
      return
    }

    // Trong trường hợp là souvenior thì sẽ đổi url khác.
    const URL = isTypeSouvenir
      ? `/restaurants/${restaurantId}/requests`
      : `/restaurants/${restaurantId}/tables/${tableId}/requests`

    try {
      setLoadingSubmit(true)
      const response = await request().post(URL, {
        requests: formattedData() || [],
        number_of_people: Number(localStorage.getItem(STORAGE_KEYS.NUMBER_OF_PEOPLE)),
      })
      if (response?.data?.status === loadingStates.success) {
        // Đối với trường hợp separate order sẽ trả về serving_session_id
        saveServingSessionID(response.data?.serving_session_id || '')
        if (isTypeSouvenir) {
          setIsNotify(true) // vì đối với souvenir thì khi tạo request trạng thái sẽ là confirm luôn
        }
        setError(false)
        dispatch(clearAllCart())
        navigateToSuccessScreen()
      }
    } catch (error) {
      setMessageErr(getMessageOrderError(error))
      if (error.response.data?.item_error_id) {
        setIdErrorOrder(error.response.data?.item_error_id)
        setShowPopupError(true)
      }
    } finally {
      setLoadingSubmit(false)
    }
  }

  const renderPopupDeleteItem = () => {
    if (!showPopupError) return null

    if (messageErr) setMessageErr('')

    return (
      <PopupDeleteItem
        idErrorOrder={idErrorOrder}
        showPopupError={showPopupError}
        setShowPopupError={setShowPopupError}
      />
    )
  }

  const renderContentCartEmpty = () => {
    if (itemsCart.length === 0)
      return (
        <div className={cx('cart_empty')}>
          <div className={cx('inner_cart_empty')}>
            <p className={cx('description')}>{`${t('descriptions.cart_empty')}...`}</p>
          </div>
        </div>
      )
  }

  const renderTotalMoney = () => {
    if (itemsCart.length)
      return (
        <div className={cx('total_money')}>
          <p className={cx('label')}>{t('titles.total')}</p>
          <Typography fontSize="1.8rem" fontWeight="600" lineHeight="2" color="#000">
            {convertPrice(totalMoneyItemsCart)}
          </Typography>
        </div>
      )
  }

  const clearAllCartHandler = () => {
    dispatch(clearAllCart())
  }

  const renderActionClearAll = () => {
    if (itemsCart.length)
      return (
        <Typography
          onClick={clearAllCartHandler}
          color="#EB4319"
          textAlign="left"
          fontSize="1.6rem"
          fontWeight="600"
          sx={{
            textDecoration: 'underline',
            padding: '16px 12px',
          }}>
          {t('actions.clear_all')}
        </Typography>
      )
  }

  const renderErrorMessage = () => {
    if (messageErr) return <p className={cx('mess_error')}>{t(messageErr)}</p>
  }

  const renderContentCart = () => {
    return (
      <>
        <div className={cx('list_item_cart', { cart_error: messageErr })}>
          {itemsCart.map((item) => {
            return (
              <div key={item.primaryKey} className={cx('wrapper_item_cart')}>
                <CartItem
                  {...item}
                  setErrorItemCart={setErrorItemCart}
                  setMessErr={setMessageErr}
                  isHidePlusEnabled={isHidePlusFoodEnabled}
                />
                <div className={cx('divider')}></div>
              </div>
            )
          })}
        </div>
        <div className={cx('bottom_cart')}>
          {renderErrorMessage()}
          {messageErr ? <div className={cx('divider')}></div> : null}
          {renderTotalMoney()}
          {itemsCart.length ? <div className={cx('divider')}></div> : null}
          {renderActionClearAll()}
        </div>
      </>
    )
  }

  if (loadingSubmit)
    return (
      <Box
        sx={{
          display: 'flex',
          width: '100%',
          height: '100%',
          justifyContent: 'center',
          alignItems: 'center',
        }}>
        <CircularProgress />
      </Box>
    )

  if (error) return <ErrorServer />

  return (
    <section className={cx('wrapper')}>
      <div className={cx('inner_content')}>
        <div className={cx('header_content')}>
          <div className={cx('inner_header')}>
            <div className={cx('line')}></div>
            <p className={cx('title')}>{t('titles.in_your_cart')}</p>
          </div>
        </div>
        <div className={cx('divider')}></div>
        <div className={cx('form_content')}>
          {renderContentCartEmpty()}
          {renderContentCart()}
        </div>
      </div>
      <div className={cx('action')}>
        <ButtonBase
          className={cx('btn_order')}
          onClick={onSubmitOrder}
          disabled={itemsCart.length === 0 || errorItemCart}>
          <p className={cx('txt_btn_order')}>{t('actions.order')}</p>
        </ButtonBase>
      </div>
      {renderPopupDeleteItem()}
    </section>
  )
}

ViewCart.propTypes = {}

export default ViewCart
